import * as Icons from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * Lucide-react exporta cada ícone como named export individual; a tipagem
 * default não é index-friendly. Este helper isola o cast `as unknown as`
 * num único lugar — call sites passam só o name.
 */
export function getIcon(name: string | undefined): LucideIcon | undefined {
  if (!name) return undefined;
  const map = Icons as unknown as Record<string, LucideIcon>;
  return map[name];
}
